import type { IconData } from '@stacksjs/iconify-core'

export const baseball: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M108 200a92 92 0 1 0-92-92a92.1 92.1 0 0 0 92 92m0-152a60 60 0 1 1-60 60a60.07 60.07 0 0 1 60-60m368.937-9.74a76 76 0 0 0-107.48 0l-5.475 5.475a1173 1173 0 0 0-60.93 65.8l-.318.37l-138.829 183.562l-85.357 85.358a38.263 38.263 0 0 0-46.122 60.229l40.52 40.519a38.272 38.272 0 0 0 60.238-46.13l85.24-85.24l179.9-130.76l.841-.654a1171 1171 0 0 0 77.771-71.049a76.09 76.09 0 0 0 .001-107.48m-22.629 84.853a1140 1140 0 0 1-75.23 68.761L197.576 323.8L88.854 432.519l15.572 15.574a6.26 6.26 0 1 1-8.852 8.853l-40.52-40.519a6.26 6.26 0 0 1 8.853-8.854l15.573 15.574L188.1 314.533l139.57-184.541a1140 1140 0 0 1 58.943-63.63l5.475-5.474a44 44 0 1 1 62.225 62.225Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default baseball
